import TopicData from './TopicData';

export default TopicData;
